import service from '@/utils/axios-v2'

/**
 * 获取套餐
 * @returns 
 */
export function getCommodity() {
  return service({
    url: "/fleet/commodity/get/base/commodity",
    headers: {
      "portal-token": true
    },
    method: "get",
  })
}

/**
 * 获取账单信息
 * @returns 
 */
export function getBillInfo() {
  return service({
    url: "/fleet/order/get/bills",
    headers: {
      "portal-token": true
    },
    method: "get",
  });
}

/**
 * 获取卡信息
 * @returns 
 */
export function getCardInfo() {
  return service({
    url: "/fleet/order/get/card",
    headers: {
      "portal-token": true
    },
    method: "get",
  })
}

/**
 * 绑卡
 * @param {*} data 
 * @returns 
 */
export function bindCard(data) {
  return service({
    url: "/fleet/stripe/bind/card/v3",
    method: "post",
    data,
    headers: {
      "portal-token": true,
    }
  })
}

/**
 * 支付
 * @returns 
 */
export function pay2(data) {
  return service({
    url: "/fleet/order/self/generate/order",
    data,
    method: "post",
    headers: {
      "portal-token": true,
    },
  })
}

/**
 * 
 * @param {*} data 
 * @returns 
 */
export function changeV3(data) {
  return service({
    url: "/fleet/order/change/order",
    data,
    method: "post",
    headers: {
      "portal-token": true,
    }
  })
}

export function billingV2(page = 1, size = 10) {
  return service({
    url: "/fleet/order/pay/records",
    params: { page, size },
    headers: {
      "portal-token": true
    }
  })
}

export function payOrder(data, token) {
  return service({
    url: "/fleet/order/pay/order",
    method: "post",
    headers: {
      "portal-token": token
    },
    data,
  })
}

export function getOrderInfo(params, token) {
  return service({
    url: "/fleet/order/get/order/detail",
    params,
    method: "get",
    headers: { "portal-token": token }
  })
}
